// Portal-side auth config. ARMS uses local username/email + password + TOTP
// (TablePot pattern). MSAL was removed in S2.1.

/** Base URL for the API. Empty string = same-origin (Vite proxy in dev). */
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

/** SessionStorage key the portal uses to stash the JWT after a successful login. */
export const TOKEN_STORAGE_KEY = 'arms.session.token';
